module.exports = __webpack_public_path__ + "img/u_trash-alt.0b3c2198.svg";